



























































import { Component, Prop, Vue } from "vue-property-decorator";

import VIcon from "@/components/VIcon.vue";
import {
  SettingsListAction,
  SettingsListColumn,
  SettingsListItem,
} from "./settingsListTypes";

// One row of a settings list: dynamic cells from the column spec, pure-data action
// icon-buttons, an optional selection checkbox, an optional expand chevron and an
// optional expanded region. Holds no state and performs no side effect - every
// interaction is emitted upward.
//
// Cells render `column.value(item)` by default; a parent can take over any single cell
// through the `cell-<key>` scoped slot (see SettingsList, which forwards them).
@Component({ components: { VIcon } })
export default class SettingsListRow extends Vue {
  @Prop({ required: true }) readonly item!: SettingsListItem;
  @Prop({ required: true }) readonly columns!: SettingsListColumn[];
  @Prop({ default: () => [] }) readonly actions!: SettingsListAction[];
  @Prop({ default: "col-3" }) readonly actionsCol!: string;
  @Prop({ default: "" }) readonly rowClass!: string | string[];
  @Prop({ type: Boolean, default: false }) readonly selectionMode!: boolean;
  @Prop({ type: Boolean, default: false }) readonly selected!: boolean;
  @Prop({ type: Boolean, default: false }) readonly selectionDisabled!: boolean;
  @Prop({ type: Boolean, default: false }) readonly expandable!: boolean;
  @Prop({ type: Boolean, default: false }) readonly expanded!: boolean;
  @Prop({ default: "Mostra dettagli" }) readonly expandTitle!: string;
  @Prop({ default: "Nascondi dettagli" }) readonly collapseTitle!: string;

  get visibleActions(): SettingsListAction[] {
    return this.actions.filter(
      (action) => action.visible?.(this.item) !== false
    );
  }

  isActionDisabled(action: SettingsListAction): boolean {
    return action.disabled?.(this.item) === true;
  }

  cellText(column: SettingsListColumn): string {
    return column.value ? column.value(this.item) : "";
  }

  cellTitle(column: SettingsListColumn): string | undefined {
    return column.title?.(this.item);
  }
}
